import { render, staticRenderFns } from "./SiftDealer.vue?vue&type=template&id=bc956b5e&"
import script from "./SiftDealer.vue?vue&type=script&lang=js&"
export * from "./SiftDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc956b5e')) {
      api.createRecord('bc956b5e', component.options)
    } else {
      api.reload('bc956b5e', component.options)
    }
    module.hot.accept("./SiftDealer.vue?vue&type=template&id=bc956b5e&", function () {
      api.rerender('bc956b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/SiftDealer.vue"
export default component.exports